import { useBoundStore } from "state/bound.store";
import { useShallow } from "zustand/react/shallow";

export const useGetCategory = (categoryId?: string) => {
  const { categories } = useBoundStore(
    useShallow((s) => {
      return {
        categories: s.orgConfig?.categories,
      };
    }),
  );
  if (!categoryId) return null;

  return categories?.find((category) => category.pub_id === categoryId);
};
